import React, { useState } from "react";
import { GetStartedModal } from "../dialogs/GetStartedModal";
import { ACCENT, SectionTitle, monoFont } from "./SectionHeading";

const STEPS = [
  {
    number: "01",
    title: "Share your website",
    description:
      "Paste your URL and Fluvo securely scans your site to understand your business, customers, and engagement goals.",
  },
  {
    number: "02",
    title: "AI builds your playbook",
    description:
      "User segments, triggers, campaigns, and workflows are generated automatically. No dev work required.",
  },
  {
    number: "03",
    title: "Watch it optimize itself",
    description:
      "Fluvo adapts messaging, timing, and channels in real time based on how your users actually behave.",
  },
  {
    number: "04",
    title: "Sit back, stay informed",
    description:
      "Everything runs on autopilot. No ongoing configuration, no maintenance. Just results.",
  },
];

const HowItWorksSection = () => {
  const [isGetStartedOpen, setIsGetStartedOpen] = useState(false);

  return (
    <section
      id="how"
      className="relative z-10 border-y border-neutral-200/70 bg-white px-6 py-28 lg:px-10 lg:py-36"
      style={{ fontFamily: "var(--font-geist)" }}
    >
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-start gap-14 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-24">
        <div className="lg:sticky lg:top-32">
          <SectionTitle
            size="md"
            eyebrow="How it works"
            title="From zero to"
            em="fully automated"
            body="Four steps. No code. No consultants. Fluvo handles the heavy lifting so you can focus on your business."
          />
          <button
            type="button"
            onClick={() => setIsGetStartedOpen(true)}
            className="mt-8 inline-flex h-11 items-center rounded-full px-5 text-[14px] font-semibold text-white transition-opacity hover:opacity-90"
            style={{ background: ACCENT }}
          >
            Get started free →
          </button>
        </div>

        <ol className="grid gap-3">
          {STEPS.map((step) => (
            <li
              key={step.number}
              className="flex gap-6 rounded-2xl border border-neutral-200 bg-[#fafafa] p-6"
            >
              <span
                className="shrink-0 pt-1 text-[13px] text-neutral-400"
                style={monoFont}
              >
                {step.number}
              </span>
              <div>
                <h3 className="text-[19px] font-medium tracking-[-0.01em] text-neutral-900">
                  {step.title}
                </h3>
                <p className="mt-2 text-[15px] leading-[1.55] text-neutral-500">
                  {step.description}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>

      <GetStartedModal
        isOpen={isGetStartedOpen}
        onClose={() => setIsGetStartedOpen(false)}
      />
    </section>
  );
};

export default HowItWorksSection;
